const PROXY_URL = 'https://tolltwsfunctions-psnm.azurewebsites.net/mmapi/';
const TWS_LOGIN = 'https://tolltwsfunctions-psnm.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctions-psnm.azurewebsites.net/api/TWSForgotLogin';
const TWS_REGISTER = 'https://tolltwsfunctions-psnm.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctions-psnm.azurewebsites.net/api/twsregister?client=civilian';
const QAS = 'https://tolltwsfunctions-psnm.azurewebsites.net/api/QAS';
const AAD = 'umovemaestro.onmicrosoft.com';

module.exports = {
    PROXY_URL
    ,TWS_LOGIN
    ,TWS_FORGOT_LOGIN
    ,TWS_REGISTER
    ,QAS
    ,AAD
    ,TWS_CIVIL_REGISTER
}